var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rate',{attrs:{"is-available":_vm.isAvailable,"value":_vm.formattedValue,"is-selected":_vm.isSelected,"toggle":_vm.toggleRate}})}
var staticRenderFns = []

export { render, staticRenderFns }